import React, { useEffect, useRef } from "react";
import { Input } from "../../Components/ui/input";
import { Card, CardContent } from "../../Components/ui/card";
import {
  Dollar,
  Calender,
  refresh,
  wallet,
  Bank,
  info,
  usFlag,
} from "../../Public/assets/index";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../Components/ui/select";
import { useOverview } from "./../../hooks";
import { reFormatDate } from "./../../Utils/helperFunction";

const PaymentSummary = ({ beneficiarySelected }) => {
  const {
    amount,
    selectedCurrency,
    getFlagByCurrencyCode,
    getFlagByCurrencyCodeForBeni,
    selectedToCurrency,
    charges,
    toAmount,
    purposeOfTransfer,
    setPurposeOfTransfer,
    remarks,
    setRemarks,
    remarkError,
    setRemarkError,
    investmentAccount,
    selectedDuration,
    purposeError,
    setPurposeError,
    isHedgeFundAccount,
  } = useOverview();
  const purposeRef = useRef(null);
  const remarksRef = useRef(null);

  useEffect(() => {
    if (purposeError) {
      purposeRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    } else if (remarkError) {
      remarksRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [purposeError, remarkError]);

  useEffect(() => {
    if (investmentAccount) {
      setPurposeOfTransfer("Investment Capital");
    }
  }, [investmentAccount, setPurposeOfTransfer]);

  const getFeeDisplay = () => {
    if (!charges?.totalFees || charges.totalFees === "-") {
      return "-";
    }

    // Check if totalFees is "0" or "0.0" or "0.00"
    const isZero = parseFloat(charges.totalFees) === 0;

    if (isZero) {
      return "Free";
    }

    return `${charges.totalFees} ${selectedCurrency?.vendorCurrency}`;
  };

  const options = [
    { value: "investment_capital", label: "Investment capital" },
    { value: "transfer_to_own_account", label: "Transfer to own account" },
    { value: "education_training", label: "Education and training" },
    { value: "loan_credit_repayment", label: "Loan repayment" },
  ];

  const handlePurpose = (value) => {
    setPurposeOfTransfer(value);
    setPurposeError("");
  };

  return (
    <div className=" py-3.5 space-y-4">
      <Card className="shadow-send-money-gradient  border-[1px]  bg-[#F7F7F8] border-[#D3D4DA]">
        <CardContent className=" relative p-4 gap-4 flex items-center ">
          {/* <div className="flex items-center space-x-3"> */}
          {/* <img
            src={getFlagByCountryCode(beneficiarySelected?.country)}
            alt="US flag"
            className="rounded-full w-7 h-7"
          /> */}

          <div className="space-y-1">
            <p
              className="font-geomanistBold text-blackShade text-sm max-w-[200px] truncate"
              title={beneficiarySelected?.nameOfBeni}
            >
              {beneficiarySelected?.nameOfBeni}
            </p>
            <p className="text-xs font-geomanistBold text-blackShade">
              {beneficiarySelected?.maskAccountNo || beneficiarySelected?.iban}
              <span className=" pl-[6px] text-greyish">
                {beneficiarySelected?.bankName}
              </span>
            </p>
          </div>
          <div className="flex justify-end">
            {investmentAccount && (
              <span
                className={` absolute  top-6 right-2    rounded-full font-geomanistBold text-[12px] py-[5px]  px-[10px] bg-blueish text-white`}
              >
                Investment Account
              </span>
            )}
            {isHedgeFundAccount && (
              <span className="absolute top-6 right-2 rounded-full font-geomanistBold text-[12px] py-[5px] px-[10px] bg-[#FFE2C7] text-[#010101]">
                Hedge Fund Account
              </span>
            )}
          </div>
          {/* </div> */}
        </CardContent>
      </Card>

      <div className=" flex flex-col gap-5 relative overflow-hidden">
        <div className="absolute left-4 top-0 bottom-0 border-l-2 border-dotted h-auto  border-greyish"></div>
        <div className="space-y-1">
          <div className="absolute left-2 top-0 bg-white ">
            <div className="bg-white text-greyish">
              <img src={wallet} alt="" />
            </div>
          </div>
          <p className="text-xs font-normal  pl-10 text-greyish">You Pay</p>

          <div className="ml-10 mt-1 space-y-1 ">
            <p className="text-base  flex gap-1 font-geomanistBold text-[#22212E]">
              {amount} {selectedCurrency?.vendorCurrency}
              <img
                src={getFlagByCurrencyCode(selectedCurrency?.vendorCurrency)}
                alt=""
                className="rounded-full  my-auto w-[18px] h-[18px]"
              />
            </p>
            <p className="text-[12px] font-normal text-greyish">
              Account Balance:{" "}
              {parseFloat(
                selectedCurrency?.balance - selectedCurrency?.holdBalance
              ).toFixed(2)}{" "}
              {selectedCurrency?.vendorCurrency}
            </p>
          </div>
        </div>

        <div className="py-2">
          <div className="absolute left-2 bg-white">
            <div className="">
              <img src={Calender} alt="" />
            </div>
          </div>

          <div className="ml-10">
            <div className="flex  space-y-1  flex-col justify-center ">
              <p className=" flex  items-center text-xs  gap-2  font-normal text-greyish ">
                Transfer On
                <span className="text-xs font-normal text-blackShade">
                  {reFormatDate(new Date())}
                </span>
              </p>
              <p className="text-xs flex  font-normal text-greyish ">
                {/* {Takes 0-2 business days to arrive} */}
                Takes {selectedDuration} to arrive
              </p>
            </div>
          </div>
        </div>

        {selectedCurrency?.vendorCurrency !== "USD" && (
          <div className="py-2">
            <div className="absolute left-2  bg-white">
              <img src={refresh} alt="" />
            </div>
            <div className="space-y-2 pl-10">
              <div className=" ">
                <p className="text-xs  flex items-center gap-2 font-normal text-[#797979]  ">
                  Conversion Rate:
                  <span className="text-base  flex gap-3 font-geomanistBold text-blackShade">
                    1 {selectedCurrency?.vendorCurrency} = {charges?.rate}{" "}
                    {selectedToCurrency?.vendorCurrency}
                  </span>
                  <div className="relative group">
                    <img src={info} alt="" />
                    <div className="absolute left-1/2 -translate-x-1/2  hidden group-hover:block bottom-full w-max  mb-2  bg-blueish font-geomanistBold  text-white text-xs  leading-[24px] rounded px-2 py-1">
                      Actual rate may vary
                      <div className="absolute bottom--2 left-1/2 -translate-x-1/2 w-2 h-2 bg-blueish rotate-45 transform"></div>
                    </div>
                  </div>
                </p>
              </div>
            </div>
          </div>
        )}

        <div className="py-2">
          <div className="absolute left-1.5 bg-white">
            <img src={Dollar} alt="" />
          </div>
          <div className="space-y-2 pl-10">
            <div className="flex items-center space-x-2">
              <p className="flex  items-center gap-2 text-xs font-normal text-greyish ">
                Transfer Charges:{" "}
                <span className=" text-base  flex gap-3 font-geomanistBold text-blackShade">
                  {charges?.totalFees} {selectedCurrency?.vendorCurrency}
                </span>
                {getFeeDisplay() !== "FREE" && (
                  <div className="relative group">
                    <img src={info} alt="" />
                    <div className="absolute left-1/2 -translate-x-1/2  hidden group-hover:block bottom-full w-max  mb-2  bg-blueish font-geomanistBold  text-white text-xs  leading-[24px] rounded px-2 py-1">
                      Actual fee may vary depending on the rate
                      <div className="absolute bottom--2 left-1/2 -translate-x-1/2 w-2 h-2 bg-blueish rotate-45 transform"></div>
                    </div>
                  </div>
                )}
              </p>
            </div>
          </div>
        </div>

        <div className="py-2">
          <div className="absolute left-2 bg-white h-full ">
            <img src={Bank} alt="" />
          </div>
          <div className="space-y-2 pl-10">
            <p className="text-xs font-normal   text-greyish">Payee Gets</p>

            <div className=" mt-1 space-y-1 ">
              <p className="text-base  flex gap-3 font-geomanistBold text-blackShade">
                {toAmount}{" "}
                {investmentAccount
                  ? " USD"
                  : selectedToCurrency?.vendorCurrency}
                <img
                  src={
                    investmentAccount
                      ? usFlag
                      : getFlagByCurrencyCodeForBeni(
                          selectedToCurrency?.vendorCurrency
                        )
                  }
                  alt=""
                  className="rounded-full my-auto w-[18px] h-[18px]"
                />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-2" ref={purposeRef}>
        <p className="text-xs font-normal text-blackShade">
          Purpose of Transfer{" "}
          <span className="m-auto leading-[16px] font-[400] text-[12px] text-[#FF0004]">
            *
          </span>
        </p>
        {investmentAccount ? (
          <Input
            type="text"
            readOnly={investmentAccount}
            placeholder="Purpose of Transfer"
            value={purposeOfTransfer}
            onChange={(e) => setPurposeOfTransfer(e.target.value)}
            className={`text-sm border font-geomanistBold ${
              purposeError ? "border-red-500" : ""
            }`}
          />
        ) : (
          <Select value={purposeOfTransfer} onValueChange={handlePurpose}>
            <SelectTrigger
              className={`font-geomanistBold rounded-md ${
                purposeError ? "border-red-500" : ""
              }`}
            >
              <SelectValue placeholder="Select an option" />
            </SelectTrigger>
            <SelectContent className="z-[9999]">
              {options.map((option, index) => (
                <SelectItem
                  isLastItem={index === options.length - 1}
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
        {purposeError && (
          <p className="text-red-500 text-xs mt-1">{purposeError}</p>
        )}
      </div>
      <div className="space-y-2" ref={remarksRef}>
        <p className="text-xs font-normal text-blackShade ">
          Remarks{" "}
          <span className="m-auto leading-[16px] font-[400] text-[12px] text-[#FF0004]">
            *
          </span>
        </p>

        <Input
          type="text"
          placeholder="Remarks"
          value={remarks}
          onChange={(e) => {
            setRemarks(e.target.value);
            setRemarkError("");
          }}
          className={`text-sm border font-geomanistBold 
            ${remarkError ? "border-red-500" : ""}
            `}
        />
        {remarkError && (
          <p className="text-red-500 text-xs mt-1">{remarkError}</p>
        )}
      </div>
    </div>
  );
};

export default PaymentSummary;
